import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import Modal from 'react-modal';

import App from './js/App';
import store, { history } from './js/config/store'
import registerServiceWorker, { unregister } from './js/config/service-worker';
import withAnalytics from './js/config/analytics';

// $joyride-color: $mid-blue;
// $joyride-hole-border-radius: 0px;

import 'react-notifications/lib/notifications.css';
import 'react-select/dist/react-select.min.css';
import 'react-toggle/style.css';
import 'react-joyride/lib/react-joyride-compiled.css';
import './sass/index.css';

Modal.setAppElement('#root');

ReactDOM.hydrate(
    <Provider store={store}>
        <ConnectedRouter history={history} basename='/content'>
            <Route component={withAnalytics(App)} />
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);

// if( process.env.NODE_ENV === 'production' ) {
//     registerServiceWorker();
// } else {
    unregister();
// }



// WEBPACK FOOTER //
// ./src/index.js